const Periodos = {
    HOY: 'HOY',
    ULTIMOS_TRES_DIAS: 'ULTIMOS_TRES_DIAS',
    ULTIMA_SEMANA: 'ULTIMA_SEMANA',
    ULTIMO_MES: 'ULTIMO_MES',
    PERSONALIZADO: 'PERSONALIZADO',
}

const opcionesPeriodos = [
    { nombre: 'Hoy', valor: Periodos.HOY },
    { nombre: 'Últimos 3 días', valor: Periodos.ULTIMOS_TRES_DIAS },
    { nombre: 'Última semana', valor: Periodos.ULTIMA_SEMANA },
    { nombre: 'Últimos 30 días', valor: Periodos.ULTIMO_MES },
    { nombre: 'Personalizado', valor: Periodos.PERSONALIZADO }
]

const es = {
    firstDayOfWeek: 1,
    dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
    dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
    monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
    monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
    today: 'Hoy',
    clear: 'Limpiar',
    dateFormat: 'dd/mm/yy',
    weekHeader: 'Sm'
};

const FechasFunctions = {
    traerFechasPredefinidas: (seleccion: string) => {
        const dayMillisecs = 24 * 60 * 60 * 1000;
        const fechaInicio = new Date();
        fechaInicio.setHours(0);
        fechaInicio.setMinutes(0);
        fechaInicio.setSeconds(0);
        fechaInicio.setMilliseconds(0);
        const fechaFin = new Date();
        fechaFin.setMinutes(59);
        fechaFin.setSeconds(59);
        fechaFin.setMilliseconds(999);
        fechaFin.setHours(23);
        let newTime = fechaInicio.getTime();
        switch (seleccion) {
            case Periodos.HOY:
                break;
            case Periodos.ULTIMOS_TRES_DIAS:
                newTime = fechaInicio.getTime() - (dayMillisecs * 2);
                break;
            case Periodos.ULTIMA_SEMANA:
                newTime = fechaInicio.getTime() - (dayMillisecs * 7);
                break;
            case Periodos.ULTIMO_MES:
                newTime = fechaInicio.getTime() - (dayMillisecs * 30);
                break;
            default:
                break;
        }
        fechaInicio.setTime(newTime);
        return { fechaInicio, fechaFin };
    }
    
}
export default { FechasFunctions, Periodos, opcionesPeriodos, es };